import React from "react";
import { showModalConfirm, ModalType, ModalControls } from "components/Modal";
import QuestionnaireForm from "modules/workflow/components/QuestionnaireForm";
import { QuestionType } from "modules/workflow/types/Questionnaire";

export const resubmitModal = ({
  onSubmit,
}: {
  onSubmit: (reason: string) => Promise<void> | void;
}) => {
  let modalControls: ModalControls;
  let submitHandle: () => Promise<void>;

  showModalConfirm({
    title: "Add a reason for resubmission",
    type: ModalType.NOTIFICATION,
    labelConfirm: "Submit",
    getModalControls: (controls) => (modalControls = controls),
    renderContent: (controls) => (
      <>
        <QuestionnaireForm
          getSubmitHandle={(handle) => (submitHandle = handle)}
          onSavePageAnswers={(_, values) => {
            const reason = values.reason as string;
            onSubmit(reason);
            controls.busy(true);
            controls.close();
          }}
          questionsBySubquestionnaire={{
            resubmitForm: {
              reason: {
                id: "reason",
                data: {
                  descriptions: [{ label: "Reason for resubmission" }],
                  required: true,
                  definition: {
                    type: QuestionType.LONG_TEXT,
                  },
                },
              },
            },
          }}
          questionnairePages={[
            {
              id: "resubmitPage",
              questionnaireId: "resubmitForm",
              caption: "",
              sections: [{ caption: "", questions: ["reason"] }],
            },
          ]}
        />
      </>
    ),

    onCancel: () => {
      modalControls.close();
    },

    onConfirm: async () => {
      modalControls?.busy(true);
      if (submitHandle) await submitHandle();
      modalControls.close();
    },
  });
};
